import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openModal } from "../../redux/features/modalSlice";
import { setSubCategoryFilters } from '../../redux/features/filtersSlice';
import SearchBar from "../../common/Search";
import Pagination from "../../common/Pagination";
// import { useGetSubCategoriesQuery, useDeleteSubCategoryMutation, } from "../../redux/services/subCategoriesService/subCategories.Services";
import { useGetSubCategoriesQuery, } from "../../redux/services/subCategoriesService/subCategories.Services";
function SubCategories() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filters = useSelector((state) => state.filters.subCategory);
  const { data, isLoading, isError, } = useGetSubCategoriesQuery(filters);
  // const [deleteSubcategory] = useDeleteSubCategoryMutation();
  const isActive = (status) => {
    return status === "active" || status === "Active" || status === 1 || status === true;
  };
  const subCategoriesData = data?.data || [];
  const pagination = data?.pagination || {};
  const totalPages = pagination?.totalPages || 0;
  const showPagination = totalPages > 1;
  const hasData = subCategoriesData?.length > 0;
  // const handleDelete = async (id) => {
  //   try {
  //     await deleteSubcategory(id).unwrap();
  //     alert("Subcategory Deleted Successfully");

  //   } catch (error) {
  //     console.log(error);
  //     alert("Delete Failed");

  //   }
  // };

  const handlePageChange = (page) => {
    dispatch(
      setSubCategoryFilters({
        page,
      })
    );
  };
  const handleSearch = (value) => {
    dispatch(
      setSubCategoryFilters({
        search: value,
        page: 1,
      })
    );
  }
  // LOADING
  if (isLoading) {
    return <h3>Loading...</h3>;
  }

  if (isError) {
    return <h3>Something went wrong</h3>;
  }

  return (
    <div>
      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              All Sub Categories
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page" >
                All Sub Categories
              </li>
            </ol>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/add-sub-category")}
          >
            Add Sub Category
          </button>
        </div>
        <div className="mb-3">
          <SearchBar
            search={filters.search}
            setSearch={handleSearch}
            placeholder="Search Sub Categories..."
          />
        </div>
      </div>
      <div className="st-wrapper-card">
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle mb-0">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Sub Category</th>
                <th>Category</th>
                <th>Description</th>
                <th>Image</th>
                <th>Status</th>
                <th>Change Status</th>
                <th className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {
                subCategoriesData?.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      {(index + 1) + (filters.page - 1) * filters.limit}
                    </td>
                    <td className="fw-semibold">
                      {item.name}
                    </td>
                    <td>
                      {item.category_name}
                    </td>
                    <td>
                      {item?.description || "NA"}
                    </td>
                    <td>
                      <img
                        src={`${item?.imageBaseUrl}${item.image}`}
                        alt={item.name}
                        width="50"
                        height="50"
                        style={{
                          objectFit: "cover",
                          borderRadius: "8px"
                        }}
                      />
                    </td>
                    <td> {item.status === "active" || item.status === 1 ? "Active" : "Inactive"}</td>
                    <td style={{ width: "150px" }}>
                      <div className="city-status-switch">

                        <input
                          type="checkbox"
                          id={`status-${item.id}`}
                          className="city-status-input"
                          checked={isActive(item.status)}

                          onChange={() =>
                            dispatch(
                              openModal({
                                type: "status-subcategory",
                                title: "Change SubCategory Status",
                                data: {
                                  id: item._id || item.id,
                                  status: item.status,
                                  name: item.name,
                                  apiUrl: "/sub-category-status",
                                  message: `You want to change status of ${item.name}`
                                },
                              })
                            )
                          }
                        />

                        <label
                          htmlFor={`status-${item.id}`}
                          className="city-status-label"
                        >
                          <span className="city-status-ball"></span>

                          <span className="city-status-text">
                            {isActive(item.status)
                              ? "Active"
                              : "Inactive"}
                          </span>
                        </label>

                      </div>
                    </td>

                    {/* ACTIONS */}
                    <td className="text-center">

                      {/* VIEW */}
                      <button
                        className="st-action-btn st-view-btn"
                        onClick={() =>
                          dispatch(
                            openModal({
                              type: "view-subcategory",
                              title: "View Sub Category",
                              data: item,
                            })
                          )
                        }
                      >
                        <FaEye />
                      </button>

                      {/* EDIT */}
                      <button
                        className="st-action-btn st-edit-btn"
                        onClick={() =>
                          dispatch(
                            openModal({
                              type: "edit-subcategory",
                              title: "Edit Sub Category",
                              data: item,
                            })
                          )
                        }
                      >
                        <FaEdit />
                      </button>

                      {/* DELETE */}
                      <button
                        className="st-action-btn st-delete-btn"
                      onClick={() =>
  dispatch(
    openModal({
      type: "delete-subcategory",
      title: "Delete SubCategory",
      data: {
        id: item.id,
        apiUrl: "/sub-category-delete",
        message: `You are deleting ${item.name}`,
      },
    })
  )
}
                      >
                        <FaTrash />
                      </button>

                    </td>

                  </tr>

                ))
              }

            </tbody>
            <div className="d-flex justify-content-end mt-4">

             {showPagination && (
    <div className="d-flex justify-content-end mt-4">
      <Pagination
        page={filters.page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  )}

            </div>
          </table>

        </div>

      </div>

    </div>
  );
}

export default SubCategories;